import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from '@/views/LoginPage.vue'
import RegisterPage from '@/views/RegisterPage.vue'
import RegisterStart from '@/views/RegisterStart.vue'
import ResetPassword from '@/views/PasswordChange.vue'
import RegisterFinalPage from '@/views/RegisterFinalPage.vue'
import TestPage from '@/views/TestPage.vue'
import PrivatCabinet from '@/views/PrivateCabinet/PrivateCabinet'
import FormStatus from '@/views/FormStatus'
import DocumentSign from '@/views/DocumentSign'
import DiyaQrCode from '@/components/views/RegisterPage/DiyaQrCode'
import ResidentRegister from '@/components/views/RegisterPage/ResidentRegister'
import DiyaCheckData from '@/components/views/RegisterPage/DiyaCheckData'
import DiyaMobileSuccess from '@/components/views/RegisterPage/steps/DiyaMobileSuccess'
import ServerErrorPlaceholder from '@/views/ServerErrorPlaceholder'
import PcProfile from '@/views/PrivateCabinet/PcProfile'
import PcAccounts from '@/views/PrivateCabinet/PcAccounts'
import PcDocumentRequest from '@/views/PrivateCabinet/PcDocumentRequest'
import PcDocuments from '@/views/PrivateCabinet/PcDocuments'
import PcTradeLimits from '@/components/views/PrivateCabinet/PcTradeLimits'
import PcMessages from '@/views/PrivateCabinet/PcMessages'
import DiyaMobileDocSignSuccess from '@/components/views/RegisterPage/steps/DiyaMobileDocSignSuccess.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'profile', params: { lang: 'uk' } },
  },
  {
    path: '/:lang/server_is_not_available',
    name: 'server-error-placeholder',
    component: ServerErrorPlaceholder
  },
  {
    path: '/:lang/',
    name: 'private-cabinet',
    redirect: { name: 'profile', params: { lang: 'uk' } },
    component: PrivatCabinet,
    children: [
      {
        path:'/:lang/profile',
        name: 'profile',
        component: PcProfile,
        meta: {
          title: 'pc.menu.my-profile'
        }
      },
      {
        path:'/:lang/accounts',
        name: 'accounts',
        component: PcAccounts,
        meta: {
          title: 'pc.menu.funds'
        }
      },
      // {
      //   path:'/:lang/document-request',
      //   name: 'document-request',
      //   component: PcDocumentRequest,
      //   meta: {
      //     title: 'pc.menu.document-request'
      //   }
      // },
      {
        path:'/:lang/documents/all/',
        name: 'documents-all',
        component: PcDocuments,
        meta: {
          title: 'pc.menu.documents'
        }
      },
      {
        path:'/:lang/documents/waiting-for-sign',
        name: 'documents-for-sign',
        component: PcDocuments,
        meta: {
          title: 'pc.menu.documents'
        }
      },
      {
        path:'/:lang/trade-limits',
        name: 'trade-limits',
        component: PcTradeLimits,
        meta: {
          title: 'pc.menu.trade-limits'
        }
      },
      {
        path:'/:lang/messages',
        name: 'messages',
        component: PcMessages,
        meta: {
          title: 'pc.menu.messages'
        }
      },

    ]
  },
  {
    path: '/:lang/document-sign',
    name: 'document-sign',
    component: DocumentSign
  },
  {
    path: '/:lang/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/:lang/register',
    name: 'register',
    component: RegisterStart
  },
  {
    path: '/:lang/register/check',
    name: 'register-check-data',
    component: DiyaCheckData
  },
  {
    path: '/:lang/register/form',
    name: 'register-form',
    component: RegisterPage
  },
  {
    path: '/:lang/password-change',
    name: 'password-change',
    component: ResetPassword
  },
  {
    path: '/:lang/register/final',
    name: 'register-final-page',
    component: RegisterFinalPage
  },
  {
    path: '/:lang/test-page',
    component: TestPage
  },
  {
    path: '/:lang/form-status',
    name: 'form-status',
    component: FormStatus
  },
  {
    path: '/:lang/register/sharing',
    name: 'diya-qr-code',
    component: DiyaQrCode
  },
  {
    path: '/:lang/register/sharing/success',
    name: 'diya-qr-success',
    component: DiyaMobileSuccess
  },
  {
    path: '/:lang/document-sign/sharing',
    name: 'diya-qr-code-sign',
    component: DiyaQrCode
  },
  {
    path: '/:lang/document-sign/sharing/success',
    name: 'diya-qr-sign-success',
    component: DiyaMobileDocSignSuccess
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



export default router
